import React, { useEffect, useState } from "react";
import { ShoppingList } from "../shopping/ShoppingList";

import { PanelWithBreadCrumbAndSearchBox } from "../panels/PanelWithBreadCrumbAndSearchBox";
import { PanelWithHeader } from "../panels/PanelWithHeader";
import {
  apiAddOrUpdateShoppingItem,
  apiGetMyShoppingItems,
  apiQuickUpdateShoppingItem,
} from "../../services/ShoppingService";
import { apiGetMyToDo } from "../../services/ToDoService";
import { ShoppingAddOrUpdatePopup } from "../shopping/ShoppingAddOrUpdatePopup";

let config = require("../../configuration/config");

export const ShoppingPage = () => {
  let initRowsInCategories: any[] = [];
  const [data, setData] = useState({
    rowsInAllCategories: initRowsInCategories,
  });
  const [addOrUpdatePopupInformation, setAddOrUpdatePopupInformation] =
    useState({ visible: false, id: undefined });

  console.log(config.serverUrl);

  useEffect(() => {
    ensureLatestData();
  }, []);

  let handlePopupClose = () => {
    setAddOrUpdatePopupInformation({
      ...addOrUpdatePopupInformation,
      visible: false,
    });
  };

  let handleSave = (formData: any) => {
    apiAddOrUpdateShoppingItem(formData).then((response) => {
      handlePopupClose();
      ensureLatestData();
    });
  };

  let handleQuickUpdate = (id: any, completed: any) => {
    apiQuickUpdateShoppingItem({ id: id, completed: completed }).then(
      (response) => {
        ensureLatestData();
      }
    );
  };

  let ensureLatestData = () => {
    apiGetMyShoppingItems().then((response) => {
      let rowsPerCategory: any[] = [];

      response.data.forEach((row) => {
        debugger;
        let existingCategoryRows = rowsPerCategory.filter(
          (a) => a["category"] == row.category
        );

        if (existingCategoryRows.length > 0) {
          if (!existingCategoryRows[0]["rows"]) {
            existingCategoryRows[0]["rows"] = [];
            existingCategoryRows[0]["category"] = row["category"];
          }

          existingCategoryRows[0]["rows"].push(row);
        } else {
          rowsPerCategory.push({
            rows: [row],
            category: row["category"],
          });
        }
      });
      setData({ ...data, rowsInAllCategories: rowsPerCategory });
    });
  };
  debugger;
  return (
    <div className="container-fluid mt-3">
      {addOrUpdatePopupInformation.visible && (
        <ShoppingAddOrUpdatePopup
          handleClose={handlePopupClose}
          handleConfirmation={handleSave}
        />
      )}
      <PanelWithBreadCrumbAndSearchBox currentPageName="Nákupníček" />
      {/* <-- ~Heading --> */}

      <input
        onClick={() => {
          setAddOrUpdatePopupInformation({
            ...addOrUpdatePopupInformation,
            visible: true,
          });
        }}
        className="btn btn-info btn-block"
        style={{ maxWidth: "300px", marginBottom: "25px", marginLeft: "1px" }}
        type="button"
        value="Přidat položku"
      />
      <div className="row wow fadeIn">
        {data.rowsInAllCategories &&
          data.rowsInAllCategories.length > 0 &&
          data.rowsInAllCategories.map((rowsInCategory) => {
            return (
              <div className="col-lg-3 col-md-6 mb-4">
                <ShoppingList
                  header={rowsInCategory["category"]}
                  rows={rowsInCategory["rows"]}
                  quickUpdateToShoppingItem={handleQuickUpdate}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
